// Create types
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_RESET = 'USER_CREATE_RESET';

// Show types
/*export const USER_SHOW_ERROR = 'USER_SHOW_ERROR';
export const USER_SHOW_LOADING = 'USER_SHOW_LOADING';
export const USER_SHOW_RETRIEVED_SUCCESS = 'USER_SHOW_RETRIEVED_SUCCESS';
export const USER_SHOW_RESET = 'USER_SHOW_RESET';*/

// Update types
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';
export const USER_UPDATE_UPDATE_SUCCESS = 'USER_UPDATE_UPDATE_SUCCESS';
export const USER_UPDATE_RETRIEVE_SUCCESS = 'USER_UPDATE_RETRIEVE_SUCCESS';
export const USER_UPDATE_EXPORT_SUCCESS = 'USER_UPDATE_EXPORT_SUCCESS';

// Delete types
/*export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
export const USER_DELETE_LOADING = 'USER_DELETE_LOADING';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_RESET = 'USER_DELETE_RESET';*/

// List types
/*export const USER_LIST_ERROR = 'USER_LIST_ERROR';
export const USER_LIST_LOADING = 'USER_LIST_LOADING';
export const USER_LIST_RESET = 'USER_LIST_RESET';
export const USER_LIST_VIEW = 'USER_LIST_VIEW';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';*/


// Auth types
export const USER_AUTH_LOGIN = 'USER_AUTH_LOGIN';
export const USER_AUTH_LOGGED = 'USER_AUTH_LOGGED';
export const USER_AUTH_LOGOUT = 'USER_AUTH_LOGOUT';
export const USER_AUTH_SHOW = 'USER_AUTH_SHOW';
export const USER_AUTH_HIDE = 'USER_AUTH_HIDE';
export const USER_AUTH_CLEAR_JWT = 'USER_AUTH_CLEAR_JWT';
export const USER_SET_DATA = 'USER_SET_DATA';
export const USER_REFRESH_TOKEN = 'USER_REFRESH_TOKEN';

export const USER_AUTH_SHOW_FACEBOOK_CREATE = 'USER_AUTH_SHOW_FACEBOOK_CREATE';
export const USER_AUTH_FACEBOOK_LOGIN = 'USER_AUTH_FACEBOOK_LOGIN';
export const USER_AUTH_FACEBOOK_LOGOUT = 'USER_AUTH_FACEBOOK_LOGOUT';

// Password recovery
export const PASSWORD_RECOVERY_RESET = 'PASSWORD_RECOVERY_RESET';

// Remaining questions
export const USER_GET_MIN_REMAINING_QUESTIONS = 'USER_GET_MIN_REMAINING_QUESTIONS';



// WEBPACK FOOTER //
// ./src/store/modules/user/mutation-types.js